// import useStore from "./store/store";
// import { useEffect } from "react";
// import {
//   // BrowserRouter as Router,
//   Routes,
//   Route,
//   useLocation,
//   Navigate,
// } from "react-router-dom";
// import axios from "axios";
// import "./App.css";
// import SignIn from "./components/signin";
// import Navbar from "./components/nav";
// import NewSearch from "./pages/newsearch";
// import Searches from "./pages/searches";
// import Clients from "./components/clients";
// import NotFound from "./components/notfound";
// import Home from "./pages/home";
// import IndividualSearch from "./components/individualsearch";
// import Properties from "./pages/properties";
// import FileUploadDropzone from "./components/upload";
// import ApartmentUrlFileUploadDropzone from "./components/uploadApartmentUrl";
// import AllFieldsFileUploadDropzone from "./components/uploadAllFields";
// import { LicenseInfo } from "@mui/x-license-pro";
// import Storage from "./pages/storage";
// import Video from "./components/storage/video";
// import Folder from "./components/storage/folder";
// import Document from "./components/storage/document";
// import Image from "./components/storage/image";
// import AddClient from "./components/addclient";
// import SharedUnits from "./components/sharedUnits/SharedUnits";
// import Commission from "./pages/Commission";
// import Chats from "./pages/Chats";
// import ConversationCategory from "./pages/ConversationCategories";
// import PrivateRoute from "./PrivateRoute";
// import { useAuth } from "./context/AuthProvider";
// import Unauthorized from "./helpers/UnauthorizedPage";
// import { ToastContainer } from "react-toastify";

// LicenseInfo.setLicenseKey(process.env.REACT_APP_PUBLIC_MUI_LICENSE_KEY);
// axios.defaults.headers.common["X-API-Key"] = process.env.REACT_APP_API_KEY;

// function App() {
//   const location = useLocation();
//   const user = useStore((state) => state.user);

//   const { isAuthenticated } = useAuth();

//   // useEffect(() => {}, [user]);
//   useEffect(() => {
//     if (location?.pathname === "/shared-units") {
//       document.title = "Client Portal";
//     } else {
//       document.title = "Sidekick";
//     }
//   }, [location]);

//   return (
//     <div className="w-full">
//       <ToastContainer position="top-right" autoClose={2000} />
//       {/* <Router> */}

//       <Routes>
//         <Route path="/video" element={<Video />} />
//         <Route path="/folder" element={<Folder />} />
//         <Route path="/document" element={<Document />} />
//         <Route path="/image" element={<Image />} />
//         <Route path="/DFW" element={<AddClient />} />
//         <Route path="/ATX" element={<AddClient />} />
//         <Route path="/shared-units" element={<SharedUnits />} />

//         <Route
//           path="/login"
//           element={
//             isAuthenticated ? (
//               <Navigate replace to="/" />
//             ) : (
//               <div className="flex flex-col justify-center items-center h-screen">
//                 {/* <span className="text-3xl font-bold">Sidekick</span> */}
//                 <SignIn />
//               </div>
//             )
//           }
//         />

//         {/* <Route
//             path="/login"
//             element={
//               <div className="flex flex-col justify-center items-center h-screen">
//                 <span className="text-3xl font-bold">Sidekick</span>
//                 <SignIn />
//               </div>
//             }
//           /> */}

//         <Route
//           path="*"
//           element={
//             <>
//               <Navbar />
//               <div className="flex-grow overflow-auto ">
//                 <Routes>
//                   <Route
//                     path="/"
//                     element={
//                       <PrivateRoute>
//                         <Home />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/search"
//                     element={
//                       <PrivateRoute>
//                         <NewSearch />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/search/:id"
//                     element={
//                       <PrivateRoute>
//                         <IndividualSearch />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/searches"
//                     element={
//                       <PrivateRoute>
//                         <Searches />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/clients"
//                     element={
//                       <PrivateRoute>
//                         <Clients />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/conversations"
//                     element={
//                       <PrivateRoute>
//                         <ConversationCategory />
//                       </PrivateRoute>
//                     }
//                   >
//                     {/* Matches /conversations and /conversations/:category */}
//                     <Route
//                       path=":category"
//                       element={
//                         <PrivateRoute>
//                           <ConversationCategory />
//                         </PrivateRoute>
//                       }
//                     />

//                     {/* Matches /conversations/:category/chats and /conversations/:category/chats/:id */}
//                     <Route
//                       path=":category/chats/*"
//                       element={
//                         <PrivateRoute>
//                           <Chats />
//                         </PrivateRoute>
//                       }
//                     />
//                   </Route>
//                   <Route
//                     path="/properties"
//                     element={
//                       <PrivateRoute>
//                         <Properties />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/admin"
//                     element={
//                       <PrivateRoute>
//                         <FileUploadDropzone />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route
//                     path="/admin-apartment-url"
//                     element={<ApartmentUrlFileUploadDropzone />}
//                   />
//                   <Route
//                     path="/update-property"
//                     element={<AllFieldsFileUploadDropzone />}
//                   />
//                   <Route
//                     path="/file-storage"
//                     element={
//                       <PrivateRoute>
//                         <Storage />
//                       </PrivateRoute>
//                     }
//                   />
//                   <Route path="*" element={<NotFound />} />
//                   <Route path="/not-authorized" element={<Unauthorized />} />
//                   {/* {user && user?.role === "admin" && <Route path="/commission" element={<PrivateRoute><Commission/></PrivateRoute>}/> } */}
//                   <Route
//                     path="/commission"
//                     element={
//                       <PrivateRoute>
//                         <Commission />
//                       </PrivateRoute>
//                     }
//                   />
//                 </Routes>
//               </div>
//             </>
//           }
//         />
//       </Routes>

//       {/* </Router> */}
//     </div>
//   );
// }

// export default App;

import useStore from "./store/store";
import { useEffect } from "react";
import {
  // BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import "./App.css";
import SignIn from "./components/signin";
import Navbar from "./components/nav";
import NewSearch from "./pages/newsearch";
import Searches from "./pages/searches";
import Clients from "./components/clients";
import NotFound from "./components/notfound";
import Home from "./pages/home";
import IndividualSearch from "./components/individualsearch";
import Properties from "./pages/properties";
import FileUploadDropzone from "./components/upload";
import ApartmentUrlFileUploadDropzone from "./components/uploadApartmentUrl";
import AllFieldsFileUploadDropzone from "./components/uploadAllFields";
import { LicenseInfo } from "@mui/x-license-pro";
import Storage from "./pages/storage";
import Video from "./components/storage/video";
import Folder from "./components/storage/folder";
import Document from "./components/storage/document";
import Image from "./components/storage/image";
import AddClient from "./components/addclient";
import SharedUnits from "./components/sharedUnits/SharedUnits";
import Commission from "./pages/Commission";
import Chats from "./pages/Chats";
import ConversationCategory from "./pages/ConversationCategories";
import PrivateRoute from "./PrivateRoute";
import PermissionRoute from "./PermissionRoute";
import { useAuth } from "./context/AuthProvider";
import Unauthorized from "./helpers/UnauthorizedPage";
import { ToastContainer } from "react-toastify";
import { PERMISSIONS } from "./constants/access.constant";

LicenseInfo.setLicenseKey(process.env.REACT_APP_PUBLIC_MUI_LICENSE_KEY);
axios.defaults.headers.common["X-API-Key"] = process.env.REACT_APP_API_KEY;

function App() {
  const location = useLocation();

  const { isAuthenticated, isHydrated } = useAuth();

  useEffect(() => {
    if (location?.pathname === "/shared-units") {
      document.title = "Client Portal";
    } else {
      document.title = "Sidekick";
    }
  }, [location]);

  return (
    <div className="w-full">
      <ToastContainer position="top-right" autoClose={2000} />

      <Routes>
        <Route path="/video" element={<Video />} />
        <Route path="/folder" element={<Folder />} />
        <Route path="/document" element={<Document />} />
        <Route path="/image" element={<Image />} />
        <Route path="/DFW" element={<AddClient />} />
        <Route path="/ATX" element={<AddClient />} />
        <Route path="/shared-units" element={<SharedUnits />} />

        <Route
          path="/login"
          element={
            !isHydrated ? null : isAuthenticated ? (
              <Navigate replace to="/" />
            ) : (
              <div className="flex flex-col justify-center items-center h-screen">
                <SignIn />
              </div>
            )
          }
        />

        <Route
          path="*"
          element={
            <>
              <Navbar />
              <div className="flex-grow overflow-auto">
                <Routes>
                  <Route
                    path="/"
                    element={
                      <PrivateRoute>
                        <Home />
                      </PrivateRoute>
                    }
                  />

                  <Route
                    path="/search"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.SEARCH_CREATE]}>
                        <NewSearch />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/search/:id"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.SEARCH_VIEW]}>
                        <IndividualSearch />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/searches"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.SEARCH_VIEW]}>
                        <Searches />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/clients"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.CLIENT_VIEW]}>
                        <Clients />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/conversations"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.THREAD_VIEW]}>
                        <ConversationCategory />
                      </PermissionRoute>
                    }
                  >
                    <Route
                      path=":category"
                      element={
                        <PermissionRoute permissions={[PERMISSIONS.THREAD_VIEW]}>
                          <ConversationCategory />
                        </PermissionRoute>
                      }
                    />

                    <Route
                      path=":category/chats/*"
                      element={
                        <PermissionRoute permissions={[PERMISSIONS.THREAD_VIEW]}>
                          <Chats />
                        </PermissionRoute>
                      }
                    />
                  </Route>

                  <Route
                    path="/properties"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.PROPERTY_VIEW]}>
                        <Properties />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/admin"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.PROPERTY_CREATE, PERMISSIONS.PROPERTY_EDIT, PERMISSIONS.PROPERTY_IMPORT]}>
                        <FileUploadDropzone />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/admin-apartment-url"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.PROPERTY_EDIT, PERMISSIONS.PROPERTY_IMPORT]}>
                        <ApartmentUrlFileUploadDropzone />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/update-property"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.PROPERTY_EDIT, PERMISSIONS.PROPERTY_IMPORT]}>
                        <AllFieldsFileUploadDropzone />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/file-storage"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.DRIVE_VIEW]}>
                        <Storage />
                      </PermissionRoute>
                    }
                  />

                  <Route
                    path="/commission"
                    element={
                      <PermissionRoute permissions={[PERMISSIONS.COMMISSION_VIEW]}>
                        <Commission />
                      </PermissionRoute>
                    }
                  />

                  <Route path="/not-authorized" element={<Unauthorized />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
            </>
          }
        />
      </Routes>
    </div>
  );
}

export default App;